// ReactPDFStyle.js
import { Font, StyleSheet } from "@react-pdf/renderer";
import ManropeRegular from "../../assets/fonts/manrope/Manrope-Regular.ttf";
import ManropeMedium from "../../assets/fonts/manrope/Manrope-Medium.ttf";
import ManropeSemiBold from "../../assets/fonts/manrope/Manrope-SemiBold.ttf";
import ManropeBold from "../../assets/fonts/manrope/Manrope-Bold.ttf";
import ManropeExtraBold from "../../assets/fonts/manrope/Manrope-ExtraBold.ttf";

Font.register({
  family: "Manrope",
  fonts: [
    {
      src: ManropeRegular,
      fontWeight: 400,
    },
    {
      src: ManropeMedium,
      fontWeight: 500,
    },
    {
      src: ManropeSemiBold,
      fontWeight: 600,
    },
    {
      src: ManropeBold,
      fontWeight: 700,
    },
    {
      src: ManropeExtraBold,
      fontWeight: 900,
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
    paddingTop: 40, // space for header
    paddingBottom: 50, // space for footer
    paddingHorizontal: 40,
    marginLeft: 10,
  },

  ////////////////////// HEADER /////////////////////
  header: {
    position: "absolute",
    top: 20,
    left: 40,
    right: 40,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  headerLeft: {
    fontSize: 12,
    fontWeight: "bold",
  },

  headerCenter: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
  },

  headerRight: {
    fontSize: 12,
  },

  ////////////////////// FOOTER /////////////////////
  footer: {
    position: "absolute",
    bottom: 30,
    left: 40,
    right: 40,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },

  footerLeft: {
    fontSize: 10,
  },

  footerCenter: {
    fontSize: 10,
    textAlign: "center",
  },

  footerRight: {
    fontSize: 10,
  },

  footer2: {
    position: "absolute",
    bottom: -30,
    right: 30,
    flexDirection: "row",
    justifyContent: "flex-end",
    // alignItems: "center",
    width: "100%",
  },

  footerLeft2: {
    fontSize: 10,
  },

  footerCenter2: {
    fontSize: 10,
    textAlign: "center",
  },

  footerRight2: {
    fontSize: 10,
  },

  ////////////////////// CONTENT /////////////////////
  content: {
    flexGrow: 1,
    marginTop: 20,
  },

  section: {
    paddingTop: 20,
    marginBottom: 10,
  },

  text: {
    fontSize: 33,
    letterSpacing: 2,
    fontFamily: "Manrope",
    fontWeight: 900,
    marginTop: 5,
    marginBottom: 3,
  },

  text2: {
    fontSize: 14,
    letterSpacing: 1,
    fontWeight: "bold",
    color: "#585858",
    marginBottom: 0,
  },

  image: {
    width: "40%",
    height: 70,
    paddingTop: 10,
    marginBottom: 30,
  },

  image2: {
    position: "absolute",
    top: -40,
    right: -30,
    flexDirection: "row",
    justifyContent: "flex-end",
    width: "40%",
    height: 250,
    marginBottom: 30,
  },

  image5: {
    position: "absolute",
    top: 112,
    left: -50,
    flexDirection: "row",
    width: "80%",
    height: "82vh",
  },

  ////////////////////// TABLE /////////////////////
  formName: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 14,
    color: "black",
    paddingLeft: 5,
    paddingBottom: 5,
    letterSpacing: 1,
  },

  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },

  tableRow: {
    flexDirection: "row",
  },

  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 5,
    backgroundColor: "#217C7C",
    // textAlign: "center",
  },

  tableCol2: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    padding: 7,
  },

  tableCell: {
    fontSize: 11,
  },

  tableHeaderRow: {
    backgroundColor: "#f0f0f0",
  },

  tableHeaderText: {
    fontFamily: "Manrope",
    fontWeight: 900,
    fontSize: 14,
    color: "white",
    letterSpacing: 1,
  },

  greenLine: {
    height: 5,
    backgroundColor: "#217C7C",
    marginTop: 0,
    marginBottom: 28,
    width: "95%",
  },

  flexDiv: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },

  flexTxt: {
    fontSize: 14,
    fontWeight: "bold",
    letterSpacing: 1,
  },

  flexTxt2: {
    fontSize: 9,
    fontWeight: "normal",
    // letterSpacing: 1,
    color: "#585858",
    paddingTop: 5,
  },

  flexTxt3: {
    fontSize: 10,
    paddingTop: 6,
    paddingLeft: 25,
  },

  image3: {
    width: "20%",
    height: "auto",
    marginBottom: 30,
    transform: "rotate(-90deg)",
  },

  image4: {
    width: "6%",
    height: "70%",
    marginBottom: 30,
  },
});
